<template lang="pug">
    .complete-wrapper
      div <h2>You are now registered for <a :href="'/events/view/'+currentEvent['url']">{{ currentEvent['name'] }}</a></h2>
        p(v-if="currentEvent['start_date'] == currentEvent['end_date']") The event takes place on {{ formatDate(currentEvent['start_date']) }}
        p(v-if="currentEvent['start_date'] != currentEvent['end_date']") The event takes place from {{ formatDate(currentEvent['start_date']) }} to {{ formatDate(currentEvent['end_date']) }}

        div(v-if="currentEvent.modules.length > 1")
          div(v-for="(enrolmentId, registeredModule) in registered['modules']").confirmed-model
            h3
                | {{ modules[registeredModule]['title'] }}
                span(v-if="modules[registeredModule]['full']" style="color: #a94442;") &nbsp;(you are on the waiting list for this course)
            p {{ formatDate(modules[registeredModule]['start_date']) }}
            p {{ formatTime(modules[registeredModule]['start_time']) }} - {{ formatTime(modules[registeredModule]['end_time']) }}

</template>

<script>
import { mapGetters } from 'vuex'
var moment = require('moment');

  export default {
    name: "complete",

    data() {
      return {
        test: 'This is a test'
      }
    },

    computed: mapGetters([
      'currentEvent',
      'modules',
      'registered',
      'timeFormat',
      'dateFormat'
    ]),

    methods: {
      formatDate(date) {
          return moment(date, this.$store.dateFormat).format("dddd D MMM YYYY")
      },

      formatTime(time) {
          return moment(time, this.timeFormat).format("h:mma")
      },

    },

  }
</script>

<style lang="stylus">
.confirmed-model p
  margin-bottom: 2px

.confirmed-model h3
  margin-bottom: 2px

h2
  margin-bottom 2px
</style>



// WEBPACK FOOTER //
// src/components/Confirm.vue